<template>
  <div class="d-flex justify-content full-height">

    <div class="d-flex align-items-center">
  <div class="left-center bg-white borderRadius p-1 leftBox ml-1">
    <div>
    <router-link :to="`/index/user`" class="d-flex justify-contentc-enter align-items-center flex-column mt-1">
    <img src="../assets/home.png" alt="首页" title="首页">
    <div class="iconTitle gap">首页</div>
    </router-link>
  </div>
  <div>
    <router-link :to="`/index/user/newAccount`" class="d-flex justify-contentc-enter align-items-center flex-column mt-1">
    <img src="../assets/newacc.png" alt="新增账号" title="新增账号">
    <div class="iconTitle gap">新增账号</div>
    </router-link>
  </div>
  <!-- <div >
    <router-link :to="`/index/user/sucai`" class="d-flex justify-contentc-enter align-items-center flex-column mt-1">
     
    <img src="../assets/sucai.png" alt="素材管理"  title="素材管理">
    <div class="iconTitle gap">素材管理</div>
    </router-link>
  </div> -->
  <div>
    
    <router-link :to="`/index/user/promotion`" class="d-flex justify-contentc-enter align-items-center flex-column mt-1">
     
    <img src="../assets/promotion.png" alt="推广" title="推广">
    <div class="iconTitle gap">推广</div>
    </router-link>
  </div>
  </div>
</div>

    <div class="full-width">       
    
        <router-view/>
   
    </div>
    
  </div>
</template>

<script>

// import AccountPageVue from './AccountPage.vue';
export default {
  data() {
    return {
      role:0,
      needLogin:false,
      router:'account',
      showqr:false,
      promotion_qr:null
    };
  },
  components: {

  },

  mounted(){
    var token=localStorage.getItem('sessionToken');
        this.role=localStorage.getItem('role');

          if(token==undefined || token==null ||token=='')
          {
            this.needLogin=true
          }
          else
          {
            this.needLogin=false;
          }
  
          var current=this.$route.path
          this.router=current.replace('/index/','')
         
  },

  setup(){
    

 },
  methods: {
  
   

  }
};
</script>

<style scoped>



.icon{
  width:0.3rem;
  height:0.3rem;
}
.gap{
  margin-top: 0.05rem;
}
.left-center {
    
   height: max-content
    
}
.leftBox{
  z-index:999
}
.leftBox img{
  width:0.3rem;
}
.iconTitle{
  font-size: 0.15rem;
  color:#5E6772;
}
</style>
